import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';

import Button from 'components/core/Button';
import { CalendarIcon } from 'components/Icons';

import 'react-datepicker/dist/react-datepicker.css';
import {
  DatePickerTheme,
  StyledField,
  StyledIcon,
  StyledInput,
  StyledPopupActions,
} from './DateTimeInput.styles';

type TDateTimeInputProps = {
  value?: string;
  onChange: (iso: string | undefined) => void;
  placeholder?: string;
  /** Accessible name for the control, when the visible caption is a separate element. */
  label?: string;
};

const DateTimeInput = ({ value, onChange, placeholder, label }: TDateTimeInputProps) => {
  const pickerRef = useRef<DatePicker>(null);
  const parsed = value ? new Date(value) : null;
  const selected = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;

  return (
    <StyledField>
      <DatePickerTheme />
      <DatePicker
        ref={pickerRef}
        selected={selected}
        onChange={(date: Date | null) => onChange(date ? date.toISOString() : undefined)}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="MMM d, yyyy · HH:mm"
        placeholderText={placeholder}
        popperPlacement="bottom-start"
        shouldCloseOnSelect={false}
        customInput={<StyledInput aria-label={label} />}>
        <StyledPopupActions>
          <Button variant="ghost" size="sm" onClick={() => pickerRef.current?.setOpen(false)}>
            Done
          </Button>
        </StyledPopupActions>
      </DatePicker>
      <StyledIcon>
        <CalendarIcon size={16} />
      </StyledIcon>
    </StyledField>
  );
};

export default DateTimeInput;
